// extracted by mini-css-extract-plugin
export default {"sectionHeader":"sectionHeader-Ovnks","formContainer":"formContainer-OLaf9"};